import React, { Component } from 'react';
import { Link } from 'react-router-dom'

class PluginLayoutView extends Component {

  render() {
    const { user, errorMessage } = this.props;

    return (
      <div className="plugin-layout">
        {errorMessage ? (
          <div className="errorMessage">{errorMessage}</div>
        ) : null}
        <div className="plugin-layout-content">
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default PluginLayoutView;



// WEBPACK FOOTER //
// ./src/app/layouts/plugin/PluginLayoutView.js